import React, { ChangeEventHandler, CSSProperties, useContext } from "react";
import './css/singlechoice.css';
import Select, { StylesConfig } from "react-select";
import QuestContext from "../../../../components/QuestWrapper";
import { useOnboarding } from "../modular/OnboardingContext";

type SelectedStyle = {
    accentColor?: string,
    borderColor?: string,
    color?: string
}

interface SingleChoiceProps {
    options: string[];
    checked: string;
    onChange?: ChangeEventHandler<HTMLInputElement> | undefined;
    style?: CSSProperties;
    selectedStyle?: SelectedStyle;
    type?: "modal1" | "modal2" | "modal3" | string;
    hoverBackground?: string;
    key?: string | number | undefined;
}

export const SingleChoiceModal3: React.FC<SingleChoiceProps> = ({
    options,
    checked,
    onChange,
    style,
    selectedStyle = { accentColor: "#6525B3" },
    type,
    hoverBackground,
    key
}) => {

    const { themeConfig } = useContext(QuestContext.Context);
    const { themeManager } = useOnboarding()

    const containerStyle: CSSProperties = {
        ...style,
        flexDirection: type === 'modal2' ? 'column' : 'row',
        gap: type === 'modal2' ? '12px' : '8px'
    };

    const customStyles: StylesConfig<any, false, any> = {
        control: (base) => ({
            ...base,
            background: containerStyle?.background || containerStyle?.backgroundColor || "transparent",
            fontSize: containerStyle?.fontSize || "14px",
            border: `${containerStyle?.borderWidth || "1px"} solid ${containerStyle?.borderColor || style?.borderColor || "var(--neutral-grey-100, #ECECEC)"}`,
            borderRadius: "10px",
            color: containerStyle?.color || style?.color || "black",
            fontFamily: containerStyle?.fontFamily || themeManager?.getFontFamily() || "'Figtree', sans-serif",
            boxShadow: "none",
            '&:hover': {
                border: `${containerStyle?.borderWidth || "1px"} solid ${containerStyle?.borderColor || style?.borderColor || "var(--neutral-grey-100, #ECECEC)"}`,
                boxShadow: "none"
            },
            ...containerStyle
        }),
        option: (styles, { isFocused }) => ({
            ...styles,
            backgroundColor: isFocused ? hoverBackground || themeManager?.getSingleChoiceHoverBackground() || "#ADD8E6" : (containerStyle?.background || containerStyle?.backgroundColor || "#f9fafb") as string,
            color: isFocused ? "white" : containerStyle?.color || style?.color || "black",
            fontSize: containerStyle?.fontSize || "14px",
            fontFamily: containerStyle?.fontFamily || themeManager?.getFontFamily() || "'Figtree', sans-serif",
            '&:active': {
                backgroundColor: hoverBackground || themeManager?.getSingleChoiceHoverBackground() || "#ADD8E6",
                color: "white",
            },
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: (containerStyle?.background || containerStyle?.backgroundColor || "#f9fafb") as string,
        }),

        singleValue: (provided) => ({
            ...provided,
            color: containerStyle?.color || style?.color || "black",
            fontSize: containerStyle?.fontSize || "14px",
            fontFamily: containerStyle?.fontFamily || themeManager?.getFontFamily() || "'Figtree', sans-serif",
        }),
    };

    return (
        <div>
            <Select
                isSearchable={true}
                name={"selectbox"}
                options={options.map((opt: string) => { return { value: opt, label: opt } })}
                onChange={onChange}
                styles={customStyles}
                value={!!checked ? { value: checked, label: checked } : ""}
                key={key}
            />
        </div>
    );
};
